<template>
    <div style="margin-top:16px; padding-top:10px;">
        <el-table
            class="table-content"
            :data="tableData"
            v-loading="dataListLoading"
            :height="tableHeight"
            :header-cell-style="this.$globalGrayTableHeaderStyle"
            stripe
            border
        >
            <el-table-column
                :index="indexMethod"
                align="center"
                label="序号"
                type="index"
                width="50"
                :show-overflow-tooltip="true"
                fixed="left"
            ></el-table-column>
            <el-table-column
                label="审核状态"
                prop="receiveStatusName"
                header-align="center"
                align="left"
                min-width="110"
                :show-overflow-tooltip="true"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover
                        placement="bottom"
                        width="200"
                        trigger="click"
                        :ref="`popover-${scope.$index}`"
                    >
                        <span
                            slot="reference"
                            style="cursor: pointer;margin-top:10px"
                            :style="{color:checkReceiveStatus.length>0?'#1890ff':''}"
                        >
                             审核状态
                            <img src="../../../../../assets/img/shaixuan.png" alt />
                        </span>
                        <div>
                            <div id="el-checkbox-group">
                                <el-checkbox-group v-model="checkReceiveStatus">
                                    <el-checkbox
                                        :label="item.value"
                                        v-for="(item,index) in processingStateList"
                                        :key="index"
                                        class="check_box"
                                    >{{item.label}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button type="primary" size="mini" @click="getDataList">筛选</el-button>
                                <el-button size="mini" plain @click="cancelReceive">重置</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
                <template slot-scope="scope">
                    <i :class="formatterStatusClass(scope.row.historyid)"></i>
                    <span>{{formatterStatusText(scope.row.historyid)}}</span>
                </template>
            </el-table-column>

            <el-table-column
                label="投诉编号"
                prop="complaintCode"
                header-align="center"
                align="center"
                min-width="150"
                :show-overflow-tooltip="true"
            >
            <template slot="header" slot-scope="scope">
                    <el-popover placement="bottom" trigger="click" width="200">
                        <p slot="reference" style="cursor: pointer;margin-top:10px">
                            投诉编号
                            <i class="el-icon-search"></i>
                        </p>
                        <div>
                            <div style="display: inline-block;padding:12px">
                                <el-input
                                    clearable
                                    placeholder="请输入投诉编号"
                                    v-model="complaintCodeSearch"
                                ></el-input>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button plain size="mini" @click="{complaintCodeSearch='';getDataList();}">重置</el-button>
                                <el-button
                                    @click="getDataList"
                                    size="mini"
                                    type="primary"
                                >搜索</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                label="项目(标段)名称"
                prop="bidSectionName"
                header-align="left"
                min-width="200"
                :show-overflow-tooltip="true"
            >
            <template slot="header" slot-scope="scope">
                    <el-popover placement="bottom" trigger="click" width="220">
                        <p slot="reference" style="cursor: pointer;margin-top:10px">
                            项目(标段)名称
                            <i class="el-icon-search"></i>
                        </p>
                        <div>
                            <div style="display: inline-block;padding:12px">
                                <el-input
                                    clearable
                                    placeholder="请输入项目(标段)名称"
                                    v-model="bidSectionNameSearch"
                                ></el-input>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button plain size="mini" @click="{bidSectionNameSearch='';getDataList();}">重置</el-button>
                                <el-button
                                    @click="getDataList"
                                    size="mini"
                                    type="primary"
                                >搜索</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                label="项目(标段)编号"
                prop="bidSectionCode"
                align="center"
                header-align="center"
                min-width="230"
                :show-overflow-tooltip="true"
            >
            <template slot="header" slot-scope="scope">
                    <el-popover placement="bottom" trigger="click" width="220">
                        <p slot="reference" style="cursor: pointer;margin-top:10px">
                            项目(标段)编号
                            <i class="el-icon-search"></i>
                        </p>
                        <div>
                            <div style="display: inline-block;padding:12px">
                                <el-input
                                    clearable
                                    placeholder="请输入项目(标段)编号"
                                    v-model="bidSectionCodeSearch"
                                ></el-input>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button plain size="mini" @click="{bidSectionCodeSearch='';getDataList();}">重置</el-button>
                                <el-button
                                    @click="getDataList"
                                    size="mini"
                                    type="primary"
                                >搜索</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                label="投诉人员"
                prop="complainter"
                align="center"
                header-align="center"
                min-width="120"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                label="整体处理进度"
                prop="progress"
                align="left"
                min-width="460"
                :show-overflow-tooltip="true"
            ></el-table-column>

            <el-table-column
                label="投诉撤回申请人"
                prop="quashUser"
                header-align="left"
                min-width="160"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                label="撤回投诉申请时间"
                prop="createTime"
                header-align="center"
                align="center"
                min-width="180"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="60">
                <template slot-scope="scope">
                    <el-button type="text" size="small" title="查看" @click="getDetail(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="total, prev, pager, next"
            :page-size="pageSize"
            :total="total"
            :current-page="pageIndex"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
        ></el-pagination>
    </div>
</template>

<script>
import {
    getComplaintQuashList, //列表
    getComplaintQuashSave,
    getComplaintQuashDelete
} from "@/server/complaint";
export default {
    props: ["activedTab", "tableHeight", "search"],
    data() {
        return {
            tableData: [],
            dataListLoading: false,
            pageSize: 10, //每页条数
            pageIndex: 1, //当前页
            total: 8, //总条数
            checkReceiveStatus: [],
            checkEndStatus: [],
            checkOwerDeptHandleResult: [],
            checkLastHandleStatus: [],
            processingStateList: [ 
                { label: "待审核", value: -1 },
                { label: "审核通过", value: 0 },
                { label: "审核不通过", value: 1 }  //-1 待审核 0通过 1不通过  
            ],
            projectForm: {
                bidSectionName: "",
                receiveStatus: null, //受理状态字段过滤 待受理
                complaintCode: "",
                bidSectionNameOrCode: ""
            },
            complaintCodeSearch:'',
            bidSectionNameSearch:'',
            bidSectionCodeSearch:''
        };
    },
    mounted() {
        this.getDataList();
        this.getDic();
    },
    methods: {
        getDic() {
            this.$httpReq({
                url: `/complaint/listEnum/HandleStatusEnum`,
                method: "get"
            }).then(({ data }) => {
                if (data.code == 1) {
                    this.checkReceiveOptions = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });

            this.$httpReq({
                url: `/complaint/listEnum/ComplaintEndStatusEnum`,
                method: "get"
            }).then(({ data }) => {
                if (data.code == 1) {
                    this.checkEndStatusOptions = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        //分页---------------------------------------------------
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        cancelReceive() {
            //重置受理状态
            this.checkReceiveStatus = [];
            this.getDataList();
        },
        cancelDeptHandleResult() {
            //重置本部门状态
            this.checkOwerDeptHandleResult = [];
            this.getDataList();
        },
        cancelLastHandleStatus() {
            //最终处理
            this.checkLastHandleStatus = [];
            this.getDataList();
        },
        cancelCheckEndStatus() {
            this.checkEndStatus = [];
            this.getDataList();
        },
        getDetail(row) {
            // 跳转详情
            removeTabHandle("offline_complaints");
            this.$router.push({
                name: "online_complaints_exception_detail",
                query: { id: row.id, code: row.complaintCode }
            });
            sessionStorage.setItem("oneliner", JSON.stringify(row));
        },
        formatterStatusClass(historyId) {
            switch (historyId) {
                case 0:
                    return "icon-point icon-point-success";
                    break;
                case -1:
                    return "icon-point icon-point-verificationing";
                    break;
                case 1:
                    return "icon-point icon-point-danger";
                    break;
                default:
                    return "";
                    break;
            }
        },
        formatterStatusText(historyId){
            switch (historyId) {
                case 0:
                    return "审核通过";
                    break;
                case -1:
                    return "待审核";
                    break;
                case 1:
                    return "审核不通过";
                    break;
                default:
                    return "";
                    break;
            }
        },
        //专家评审记录列表
        getDataList(type,parentSearchKey) {
            let mySearch= type=="1"?parentSearchKey.bidSectionNameOrCode:''
            this.dataListLoading = true;
            let data = {
                page: this.pageIndex,
                rows: this.pageSize,
                filter: {
                    // receiveStatus:this.projectForm.receiveStatus,
                    complaintCode:this.complaintCodeSearch?this.complaintCodeSearch:(type=="1"?parentSearchKey.complaintCode:'') ,
                    bidSectionName:this.bidSectionNameSearch?this.bidSectionNameSearch:(type=="1"?parentSearchKey.bidSectionName:''),
                    historyids: this.checkReceiveStatus,
                    owerDeptHandleResultList: this.checkOwerDeptHandleResult,
                    lastHandleStatusList: this.checkLastHandleStatus,
                    endStatusList: this.checkEndStatus,
                    bidSectionCode:this.bidSectionCodeSearch||'',
                    superviseDeptCodeList:type=="1"?parentSearchKey.superviseDeptCodeList:[],
                },
                searchKey: mySearch||''
            };
            getComplaintQuashList(data).then(({ data }) => {
                if (data) {
                    this.tableData = data.rows;
                    this.total = data.total;
                    this.dataListLoading = false;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
#el-checkbox-group {
    /deep/ .el-checkbox {
        margin-left: 30px;
        line-height: 30px;
    }
}
</style>